// The "value" is the actual value in the <option> element.
export const institutionTypeDefault = {
  value: 'default',
  label: 'Vælg',
  overviewLabel: null,
}

export const institutionTypes = [
  institutionTypeDefault,
  {
    value: 'daycare',
    label: 'Daginstitution',
    overviewLabel: 'daginstitutionsområdet',
  },
  {
    value: 'schoolAgeChildcare',
    label: 'skole/SFO',
    overviewLabel: 'skole-/SFO-fritidsområdet',
  },
]

// The "value" is the actual value in the <option> element.
export const weeklyHoursDefault = { value: 'hours', label: 'Timer' }
export const weeklyHoursOptions = [
  // Add array 8-37 to the weeklyHoursOptions.
  ...Array.from({ length: 30 }, (_, index) => ({
    value: index + 8, // Add 8 so we skip the first 7.
    label: index + 8, // Add 8 so we skip the first 7.
  })),
  // Add the default to the end as we use .reverse() so defaults show at the
  // top and numbers ascend below.
  weeklyHoursDefault,
].reverse()

// The "value" is the actual value in the <option> element.
export const seniorityDefault = { value: 'year', label: 'År' }
export const seniorityOptions = [
  seniorityDefault,
  ...Array.from({ length: 21 }, (_, index) => ({
    value: index,
    label: index,
  })),
]
